import * as SentryModule from '@sentry/vue';

/**
 * @sentry/vue Wrapper method
 * @param Vue
 * @param [Sentry]
 */
export function initialize(Vue, Sentry = SentryModule) {
  const id = window.dataLayer?.find?.((data) => !!data?.userId)?.userId;
  if (!id) {
    return;
  }

  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    maxBreadcrumbs: 50,
    release: process.env.REVISION,
    environment: process.env.ENVIRONMENT,
    allowUrls: JSON.parse(process.env.ALLOW_URLS).map((str) => new RegExp(str)),
    ignoreErrors: [
      'twttr',
      'gtag',
      /Network Error/i,
      // https://github.com/tokyootakumode/com/issues/40857
      /event has no target/i,
      /Non-Error promise rejection captured with (keys|value)/i,
      /\$\.notify is not a function/i
    ],
    // @see https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-beforesend
    beforeSend: (event, hint) => {
      const error = hint && hint.originalException;
      const ignoreRegex = [/googletagmanager\.com/i];
      if (
        error &&
        error.stack &&
        ignoreRegex.some((regex) => regex.test(error.stack))
      ) {
        return null;
      }
      return event;
    }
  });

  Sentry.setUser({
    id
  });
}
